<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col class="pa-0">
        <h3 class="pt-4">{{ $t("study.rubicon.00.title") }}</h3>

        <h4 class="pt-4">{{ $t("study.rubicon.01.title") }}</h4>
        <p>
          {{ $t("study.rubicon.01.text.01") }}
        </p>
        <p>
          {{ $t("study.rubicon.01.text.02") }}
        </p>
        <p v-html="parseHtml($t('study.rubicon.01.text.03'))"></p>
        <p>
          {{ $t("study.rubicon.01.text.04") }}
        </p>
        <p>
          {{ $t("study.rubicon.01.text.05") }}
        </p>
        <p>
          {{ $t("study.rubicon.01.text.06") }}
        </p>
        <p>
          {{ $t("study.rubicon.01.text.07") }}
        </p>
        <p>
          {{ $t("study.rubicon.01.text.08") }}
        </p>

        <v-row>
          <v-col xs="12" sm="6" md="8">
            <v-img
              height="300px"
              src="@/assets/studies/studies_rubicon_biatorbagy_01.png">
            </v-img>
          </v-col>
          <v-col  xs="12" sm="6" md="4">
            <v-img
              height="300px"
              src="@/assets/studies/studies_rubicon_biatorbagy_02.png">
            </v-img>
          </v-col>
        </v-row>

        <h4 class="pt-4">{{ $t("study.rubicon.02.title") }}</h4>
        <p v-html="parseHtml($t('study.rubicon.02.text.01'))"></p>

        <v-row>
          <v-col xs="12">
            <v-img
              height="300px"
              src="@/assets/studies/studies_rubicon_biatorbagy_03.png">
            </v-img>
          </v-col>
        </v-row>

        <h4 class="pt-4">{{ $t("study.rubicon.03.title") }}</h4>
        <p>
          {{ $t("study.rubicon.03.text.01") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.02") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.03") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.04") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.05") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.06") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.07") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.08") }}
        </p>
        <p>
          {{ $t("study.rubicon.03.text.09") }}
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-end">
        {{ $t("study.author") }} <span class="primary--text">Ágoston Zoltán</span>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'StudiesRubiconBiatorbagy',
    extends: DataComponentBase,

    data: () => ({
    }),

    methods: {
      parseHtml(rawText) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(rawText, "text/html");
        return doc.querySelector("body").innerHTML;
      },
    },
  }
</script>
